import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Plants from '../views/Plants.vue'
import Schedule from '../views/Schedule.vue'
import Login from '../views/Login.vue'
import ResetPassword from '../views/ResetPassword.vue'
import SendEmailReset from '../views/SendEmailReset.vue'
import Map from '../views/Map.vue'
import Configuration from '../views/Configuration'
import { auth } from '../plugins/firebase'
import store from '../store/index'
import { userAtLeastIs, LEVEL_ADMIN } from '../plugins/checkPermission'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
		component: Home,
		meta: {
            requiresAuth: true,
        },
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
    },
    {
        path: '/sendemail',
		name: 'SendEmailReset',
		component: SendEmailReset
    },
    {
        path: '/reset',
		name: 'ResetPassword',
		component: ResetPassword
    },
    {
        path: '/map',
        name: 'Map',
        component: Map,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/plants',
        name: 'Plant',
        component: Plants,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/schedule/:id',
        name: 'Schedule',
        component: Schedule,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/configuration',
        name: 'Configuration',
        component: Configuration,
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) =>{
	const requiresAuth = to.matched.some( r => r.meta.requiresAuth )
	const requiresAdmin = to.matched.some( r => r.meta.requiresAdmin )
    
    if(requiresAuth && !auth.currentUser) return next('/login')
    else if(!requiresAuth &&auth.currentUser) return next('/map')

    if(requiresAdmin)
        if(!store.state.user.profile) return next('/')
        else if(!userAtLeastIs(store.state.user.profile.level, LEVEL_ADMIN)) return next('/')
    
    next()
        
})

export default router
